import React, { FC, useContext, useEffect } from 'react';
import { InsuranceContainerContext } from 'View/Container/InsuranceContainer/InsuranceContainerContext';
import { INSURANCE_CONTAINER_VIEW } from 'View/Container';
import { Paragraph, Headline, Link } from 'View/Common';
import { isMobile } from 'react-device-detect';
import StoreButtons from 'components/StoreButtons';
import { getInsuranceNameByClientKey } from 'utils/Constants/CooperationsVoucherClients';
import { GTM } from 'utils/gtmEvents';

export type TSuccessViewProps = {
  children?: React.ReactNode;
  className?: string;
};

export const SuccessView: FC<TSuccessViewProps> = ({ children, className = '' }) => {
  const { activeView, b2bClientKey } = useContext(InsuranceContainerContext);

  useEffect(() => {
    if (activeView === INSURANCE_CONTAINER_VIEW.SUCCESS && b2bClientKey) {
      const insuranceName = getInsuranceNameByClientKey(b2bClientKey);

      if (insuranceName) {
        GTM.successCoopPraev(insuranceName);
      }
    }
  }, [activeView, b2bClientKey]);

  if (activeView !== INSURANCE_CONTAINER_VIEW.SUCCESS) {
    return null;
  }

  return (
    <div className="success-view" id="insurance-cooperation-success-view">
      <div className="form-header">
        <Headline level={3}>Super, das hat geklappt!</Headline>
        <Paragraph>
          Öffne jetzt die 7Schläfer-App und melde dich dort mit der hier angegebenen E-Mail Adresse an. Für die Anmeldung in der App erhälst
          du erneut einen Einmalcode zur Anmeldung.
        </Paragraph>
      </div>
      {isMobile ? (
        <Link href="schlafen://open" className="mt-4">
          App öffnen
        </Link>
      ) : (
        <StoreButtons />
      )}
      {children}
    </div>
  );
};
